import { Icon20LockOutline, Icon24AddOutline } from '@vkontakte/icons';
import classNames from 'clsx';
import React, { memo } from 'react';

import styles from './CreateAlbum.css';

interface IProps {
    onClick?(): void;
    text?: string;
    disabled?: boolean;
}

export const CreateAlbum = memo(function CreateAlbum({ onClick, text = 'Создать альбом', disabled = false }: IProps) {
    return (
        <div
            className={classNames(styles.root, {
                [styles.disabled]: disabled,
            })}
            onClick={onClick}
            data-qa-id="create-album"
        >
            <div className={styles.lockIcon}>
                <Icon20LockOutline />
            </div>
            <div className={styles.addIcon}>
                <Icon24AddOutline width={20} height={20} />
            </div>
            {text}
        </div>
    );
});
